module.exports = __webpack_public_path__ + "img/DE03492.4d2d3489.png";